import { render, staticRenderFns } from "./ProvidersView.vue?vue&type=template&id=45f50aa4&scoped=true"
import script from "./ProvidersView.vue?vue&type=script&lang=js"
export * from "./ProvidersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f50aa4",
  null
  
)

export default component.exports